window.MegaMenu = window.MegaMenu || {};

$(document).ready(function () {
  // by CG
  // Main navigation toggles and animations, focused on desktop screens

  // make sure this only attaches events once
  if (!MegaMenu.loaded) {
    var $activeMenu = null;

    var isMenuActive = function () {
      return !!$(".stryx-megamenu-show").length;
    };

    var showMenuDropdown = function ($menu, menuActive, $btn) {
      $menu.removeClass("stryx-megamenu-hide");

      if ($menu) {
        if ($activeMenu == $menu) {
        } else if (menuActive) {
          $activeMenu = $menu;
          $menu.addClass("stryx-megamenu-noanimate stryx-megamenu-show");
          $btn.addClass("stryx-megamenu-active");
        } else {
          $activeMenu = $menu;
          $menu
            .removeClass("stryx-megamenu-noanimate")
            .addClass("stryx-megamenu-show");
          $btn.addClass("stryx-megamenu-active");
        }
      }
    };

    var hideMenuDropdown = function ($activeMenu, replace, $btn) {
      $(".stryx-megamenu-active").removeClass("stryx-megamenu-active");

      if (replace) {
        $(".stryx-megamenu-show")
          .addClass("stryx-megamenu-noanimate")
          .removeClass("stryx-megamenu-show");
      } else {
        // console.log("👉 MegaMenu.js : hide:menu");

        $(".stryx-megamenu-show")
          .removeClass("stryx-megamenu-show")
          .addClass("stryx-megamenu-hide");
      }

      $activeMenu = null;
    };

    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 4,
      spaceBetween: 5,
      arrows: true,
      draggable: false,
      swipe: false,
      dots: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    // $(".trigger-lvl-1").on("click", function () {
    //   var $el = $(this);
    //   var $menu = $el.next(".mega-menu-section");
    //   var menuActive = isMenuActive();
    //   if (menuActive && $activeMenu.is($menu)) {
    //     hideMenuDropdown($activeMenu, menuActive, $el);
    //   } else {
    //     showMenuDropdown($menu, menuActive, $el);
    //   }
    // });

    $(".trigger-lvl-1").on("mouseenter", function () {
      var $el = $(this);
      var $menu = $el.next(".mega-menu-section");
      var menuActive = isMenuActive();

      if (menuActive && !$activeMenu.is($menu)) {
        hideMenuDropdown($activeMenu, menuActive, $el);
      }

      showMenuDropdown($menu, menuActive, $el);
    });

    $(".trigger-lvl-1")
      .parents("ul")
      .on("mouseleave", function () {
        hideMenuDropdown();
      });

    $(".stryx--no-megamenu").on("mouseenter", function () {
      hideMenuDropdown();
    });
  }
  /* end by CG */
  /*
  $(".main-menu li .has-dropdown")
    .unbind()
    .on("click", function (e) {
      console.log("👉 MegaMenu.js : click");

      let there = document.querySelectorAll(".mega_menu_active");
      if (there.length > 0) {
        [...there].map(function (element) {
          $(element).find(".mega-menu-section .submenu").slideUp();
        });
      }

      if ($(this).hasClass("mega_menu_active")) {
        $(this).removeClass("mega_menu_active");
        $(".main-menu li .has-dropdown .mega-menu-section .submenu").slideUp();
        console.log("👉 MegaMenu.js : HIDE");
      } else {
        $(".main-menu li .has-dropdown").removeClass("mega_menu_active");
        //         $('.main-menu li .has-dropdown .mega-menu-section .submenu').slideUp();
        $(this).find(".mega-menu-section .submenu").slideDown();
        console.log("👉 MegaMenu.js : SHOW");

        $(this).addClass("mega_menu_active");
      }
    });
    
    */
  // $('.mega-menu-section .submenu').on('click', function (e) {
  //     return false;
  // })

  if (!MegaMenu.loaded) {
    $(".main-menu .submenu.mega-menu a").on("click", function (e) {
      var $el = $(this);
      var target = $el.attr("target");
      var url = $el.attr("href");

      if (target !== "_blank") {
        e.preventDefault();
        window.location.href = url;
      }
    });
  }
  MegaMenu.loaded = true;
});

$(window).on("load resize", function () {
  if ($(window).width() >= 768) {
    /*
    $("#shop .trigger-lvl-1")
      .unbind()
      .click(function (e) {
        console.log("Show mega menu");
        e.preventDefault();
        $("#header").toggleClass("shop-menu-display");
        //$('body').toggleClass('overlay-hover-mega');
        $("#header").removeClass("learn-menu-display");
      });
      */
    //     $("#learn .trigger-lvl-1")
    //       .unbind()
    //       .click(function (e) {
    //         e.preventDefault();
    //
    //         $("#header").toggleClass("learn-menu-display");
    //         //$('body').toggleClass('overlay-hover-mega');
    //         $("#header").removeClass("shop-menu-display");
    //       });

    /* HC - Mobile changes - 20 Mar '20 */
    $(document).on(
      "touchmove touchstart",
      "body.overlay-hover-mega",
      function (e) {
        var container = $(".submenu.mega-menu");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $("#header").removeClass("learn-menu-display");
          //$('body').removeClass('overlay-hover-mega');
          $("#header").removeClass("shop-menu-display");
          $("#header").removeClass("shop-menu-display");
          $("body").removeClass("overlay-hover-mega");
          $("#header").removeClass("learn-menu-display");
        }
      }
    );

    var scrolled = document.querySelector(".submenu.mega-menu");

    scrolled.addEventListener(
      "touchmove",
      function (e) {
        e.preventDefault();
      },
      false
    );
  } else {
    $("#shop .trigger-lvl-1")
      .unbind()
      .click(function (e) {
        e.preventDefault();

        if (
          $("body").hasClass("hc-second") &&
          $("body").hasClass("overlay-hover-mega")
        ) {
          $(this)
            .parents("#header")
            .addClass("shop-menu-display")
            .removeClass("learn-menu-display");
          $("body").addClass("hc-first");
          $("body").removeClass("hc-second");
        } else if (
          $("body").hasClass("hc-first") &&
          $("body").hasClass("overlay-hover-mega")
        ) {
          $(this)
            .parents("#header")
            .removeClass("shop-menu-display")
            .removeClass("learn-menu-display");
          $("body").removeClass("overlay-hover-mega");
          $("body").removeClass("hc-first");
        } else {
          $(this)
            .parents("#header")
            .addClass("shop-menu-display")
            .removeClass("learn-menu-display");
          $("body").addClass("overlay-hover-mega");
          $("body").addClass("hc-first");
        }
      });

    $("#learn .trigger-lvl-1")
      .unbind()
      .click(function (e) {
        e.preventDefault();

        if (
          $("body").hasClass("hc-first") &&
          $("body").hasClass("overlay-hover-mega")
        ) {
          $(this)
            .parents("#header")
            .addClass("learn-menu-display")
            .removeClass("shop-menu-display");
          $("body").addClass("hc-second");
          $("body").removeClass("hc-first");
        } else if (
          $("body").hasClass("hc-second") &&
          $("body").hasClass("overlay-hover-mega")
        ) {
          $(this)
            .parents("#header")
            .removeClass("learn-menu-display")
            .removeClass("shop-menu-display");
          $("body").removeClass("overlay-hover-mega");
          $("body").removeClass("hc-second");
        } else {
          $(this)
            .parents("#header")
            .addClass("learn-menu-display")
            .removeClass("shop-menu-display");
          $("body").addClass("overlay-hover-mega");
          $("body").addClass("hc-second");
        }
      });

    /* HC - Mobile changes - 20 Mar '20 */
    $(document).on(
      "touchmove touchstart",
      "body.overlay-hover-mega",
      function (e) {
        var container = $(".submenu.mega-menu");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $("#header").removeClass("learn-menu-display");
          $("body").removeClass("overlay-hover-mega");
          $("#header").removeClass("shop-menu-display");
          $("#header").removeClass("shop-menu-display");
          $("body").removeClass("overlay-hover-mega");
          $("#header").removeClass("learn-menu-display");
          $("body").removeClass("hc-second");
          $("body").removeClass("hc-first");
        }
      }
    );

    var scrolled = document.querySelector(".submenu.mega-menu");

    scrolled.addEventListener(
      "touchmove",
      function (e) {
        e.preventDefault();
      },
      false
    );
  }
});

function switchMenu(e, href) {
  // console.log("👉 MegaMenu.js : switchMenu");

  if (href === "javascript:void(0);") {
    // console.log("YES");
    let there = document.querySelectorAll(".mega_menu_active");
    if (there.length > 0) {
      [...there].map(function (element) {
        $(element).find(".mega-menu-section .submenu").slideUp();
      });
    }

    if ($(e).hasClass("mega_menu_active")) {
      $(e).removeClass("mega_menu_active");
      $(".main-menu li .has-dropdown .mega-menu-section .submenu").slideUp();
    } else {
      $(".main-menu li .has-dropdown").removeClass("mega_menu_active");
      //         $('.main-menu li .has-dropdown .mega-menu-section .submenu').slideUp();
      $(e).find(".mega-menu-section .submenu").slideDown();
      $(e).addClass("mega_menu_active");
    }
  }
}

function mouseOutMenu(e) {
  // console.log("OUT");
  e = e.parentNode.parentNode;
  let href = e.querySelector("a").getAttribute("href");
  switchMenu(e, href);
  // console.log("👉 MegaMenu.js : mouseOutMenu");
}

function mouseOverMenu(e) {
  let href = e.getAttribute("href");
  e = e.parentNode;
  switchMenu(e, href);
  // console.log("👉 MegaMenu.js : mouseOverMenu");
}
